import { useQuery } from "@tanstack/react-query";

import { clientPortalAccountsApi } from "@/api";
import { QueryKey } from "@/query/Query";

/**
 * Reads the client's current portal-access (Kund:innen-Zugang) state. Shared by the client access
 * view and the client status widget so both render from the same cache entry, which every access
 * action (invite, resend, lock, unlock, password reset) invalidates. The two-line duplication of
 * the queryFn with the client's portal-access API adapter is deliberate — the widget must stay
 * usable without pulling in the whole access page.
 */
export function useClientPortalAccountStatus(clientId: string) {
  const {
    data: status,
    isPending,
    isError,
  } = useQuery({
    queryKey: [QueryKey.ClientPortalAccountStatus, clientId],
    queryFn: () => clientPortalAccountsApi.getClientPortalAccountStatus({ clientId }),
  });

  return { status, isPending, isError };
}
